import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartTotalDisplayStyles } from "@insite/content-library/Components/CartTotalDisplay";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartTotalDisplayStyles.container = mergeToNew(cartTotalDisplayStyles.container, {
    css: css`
        background: ${getColor("secondary")};
        padding: 15px;
    `,
});

cartTotalDisplayStyles.subtotalLabel = mergeToNew(cartTotalDisplayStyles.subtotalLabel, {
    color: "text.accent",
    fontFamily: "Hind",
    weight: "bold",
});

cartTotalDisplayStyles.subtotalValue = mergeToNew(cartTotalDisplayStyles.subtotalValue, {
    color: "text.accent",
    fontFamily: "Hind",
    weight: "bold",
});

cartTotalDisplayStyles.totalLabel = mergeToNew(cartTotalDisplayStyles.totalLabel, {
    color: "text.accent",
    fontFamily: "Hind",
    weight: "bold",
});

cartTotalDisplayStyles.totalValue = mergeToNew(cartTotalDisplayStyles.totalValue, {
    color: "text.accent",
    fontFamily: "Hind",
    weight: "bold",
});
